/**
 * Authentication utility functions
 */

// List of public endpoints that don't require authentication
const PUBLIC_ENDPOINTS = [
  "authenticate",
  "crm/authenticate",
  "login",
  "register",
  "password-reset",
  "verify-email",
  "forgot-password",
  "reset-password",
  "refresh-token",
] as const;

/**
 * Check if an endpoint is public (doesn't require authentication)
 */
export const isPublicEndpoint = (endpoint: string): boolean => {
  return PUBLIC_ENDPOINTS.some((publicEndpoint) =>
    endpoint.toLowerCase().includes(publicEndpoint.toLowerCase())
  );
};

/**
 * Check if a request should include authentication headers
 */
export const shouldIncludeAuth = (
  endpoint: string,
  token: string | null
): boolean => {
  return !isPublicEndpoint(endpoint) && !!token;
};

/**
 * Get authentication headers for a request
 */
export const getAuthHeaders = (
  endpoint: string,
  token: string | null
): Record<string, string> => {
  if (shouldIncludeAuth(endpoint, token)) {
    return { "X-Admin-Authorization": `Bearer ${token}` };
  }

  return {};
};
